import React from "react";

export const STATUS_META = {
  generating: { label: "Génération…", cls: "bg-ai-soft text-ai border border-ai/30" },
  draft: { label: "Brouillon", cls: "bg-secondary text-muted-foreground border border-border" },
  pending_validation: { label: "À valider", cls: "bg-amber-50 text-amber-700 border border-amber-200" },
  changes_requested: { label: "Correction demandée", cls: "bg-purple-50 text-purple-700 border border-purple-200" },
  approved: { label: "Approuvé", cls: "bg-brand-soft text-brand border border-brand/20" },
  published: { label: "Publié", cls: "bg-emerald-50 text-emerald-700 border border-emerald-200" },
  needs_update: { label: "À actualiser", cls: "bg-orange-50 text-warn border border-orange-200" },
  archived: { label: "Archivé", cls: "bg-secondary text-muted-foreground border border-border" },
  rejected: { label: "Rejeté", cls: "bg-red-50 text-red-700 border border-red-200" },
  error: { label: "Erreur", cls: "bg-red-50 text-red-700 border border-red-200" },
};

export function StatusBadge({ status }) {
  const m = STATUS_META[status] || { label: status, cls: "bg-secondary text-muted-foreground border border-border" };
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-mono tracking-wide ${m.cls}`}>
      {status === "generating" && <span className="w-1.5 h-1.5 rounded-full bg-ai mr-1.5 ai-pulse" />}
      {m.label}
    </span>
  );
}

export function ScoreRing({ value = 0, label, size = 64, accent = "#0B3B2D" }) {
  const r = size / 2 - 6;
  const c = 2 * Math.PI * r;
  const off = c - (value / 100) * c;
  return (
    <div className="flex flex-col items-center gap-1">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E5E5E0" strokeWidth="5" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={accent} strokeWidth="5"
          strokeDasharray={c} strokeDashoffset={off} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease-out" }} />
      </svg>
      <span className="text-lg font-serif font-semibold -mt-[46px] mb-[24px]" style={{ color: accent }}>{value}</span>
      {label && <span className="text-[10px] font-mono uppercase tracking-[0.15em] text-muted-foreground">{label}</span>}
    </div>
  );
}

export function DataLabel({ children }) {
  return <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-muted-foreground">{children}</div>;
}

// tiny markdown renderer (headings, bold, lists, paragraphs)
export function Markdown({ text = "" }) {
  const lines = (text || "").split("\n");
  const blocks = [];
  let list = [];
  const flush = () => { if (list.length) { blocks.push({ t: "ul", items: [...list] }); list = []; } };
  lines.forEach((raw) => {
    const l = raw.trim();
    if (l.startsWith("### ")) { flush(); blocks.push({ t: "h3", text: l.slice(4) }); }
    else if (l.startsWith("## ")) { flush(); blocks.push({ t: "h2", text: l.slice(3) }); }
    else if (l.startsWith("- ") || l.startsWith("* ")) { list.push(l.slice(2)); }
    else if (l === "") { flush(); }
    else { flush(); blocks.push({ t: "p", text: l }); }
  });
  flush();
  const inline = (s) => s.split(/(\*\*[^*]+\*\*)/g).map((p, i) =>
    p.startsWith("**") ? <strong key={i}>{p.slice(2, -2)}</strong> : <span key={i}>{p}</span>);
  return (
    <div className="markdown-body">
      {blocks.map((b, i) => {
        if (b.t === "h2") return <h2 key={i}>{b.text}</h2>;
        if (b.t === "h3") return <h3 key={i}>{b.text}</h3>;
        if (b.t === "ul") return <ul key={i}>{b.items.map((it, j) => <li key={j}>{inline(it)}</li>)}</ul>;
        return <p key={i}>{inline(b.text)}</p>;
      })}
    </div>
  );
}

export const LANG_LABEL = { es: "Español", fr: "Français", en: "English", ru: "Русский" };
